import { useEffect, useState } from "react";

// Minimal typewriter effect. Re-types whenever `text` changes.
export function Typewriter({ text = "", speed = 45, className = "", cursor = true }) {
  const [out, setOut] = useState("");
  useEffect(() => {
    setOut("");
    if (!text) return;
    let i = 0;
    const id = setInterval(() => {
      i += 1;
      setOut(text.slice(0, i));
      if (i >= text.length) clearInterval(id);
    }, speed);
    return () => clearInterval(id);
  }, [text, speed]);
  return (
    <span className={className}>
      {out}
      {cursor && out.length < text.length && <span className="animate-pulse">▋</span>}
    </span>
  );
}
